export default __webpack_public_path__ + "media/zurb/img/events/soapbox/soapbox-img1-6993774f48f93c0b5a7f12aeb7f312eb.png";